// 견적 편집기의 시트·카드 보기 기억 — 서버가 첫 그리기부터 맞추도록 쿠키에 둔다.

export type EditorView = "sheet" | "card";

export const VIEW_COOKIE = "buildpy.quote-view";

/** 쿠키 값을 보기로. 모르는 값이면 null(화면 너비로 정한다). */
export const parseView = (value: string | undefined | null): EditorView | null =>
  value === "sheet" || value === "card" ? value : null;

/** 1년 기억. 로그인 경로 전체에서 읽히게 path=/ 로 둔다. */
export const viewCookieOf = (view: EditorView): string =>
  `${VIEW_COOKIE}=${view}; path=/; max-age=31536000; samesite=lax`;

export type TableMode = "simple" | "detail";

export const TABLE_MODE_COOKIE = "buildpy.quote-table";

/** 간단·상세 표 모드 쿠키 값. 모르는 값이면 null(기본 간단). */
export const parseTableMode = (value: string | undefined | null): TableMode | null =>
  value === "simple" || value === "detail" ? value : null;

export const tableModeCookieOf = (mode: TableMode): string =>
  `${TABLE_MODE_COOKIE}=${mode}; path=/; max-age=31536000; samesite=lax`;

// 「원가·마진 보기」 — 고객 앞에서 화면을 보일 수 있어 사람마다 끈다 · 기본 켬.
export const SHOW_COST_COOKIE = "buildpy.quote-cost";

export const DEFAULT_SHOW_COST = true;

/** 원가·마진 보기 쿠키 값. 모르는 값이면 null(기본 켬). */
export const parseShowCost = (value: string | undefined | null): boolean | null =>
  value === "show" ? true : value === "hide" ? false : null;

export const showCostCookieOf = (show: boolean): string =>
  `${SHOW_COST_COOKIE}=${show ? "show" : "hide"}; path=/; max-age=31536000; samesite=lax`;
